export default __webpack_public_path__ + "static/media/IMG_1653.fc4f4abf.jpg";